import Vue from 'vue'
import Vuetify, { VDataTableHeader } from 'vuetify/lib'
import theme from './theme'
import '@mdi/font/css/materialdesignicons.css'
import 'typeface-open-sans/index.css'
import 'typeface-dosis/index.css'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import i18n from '../locale'
import StreamLineIcons from './icons/StreamLineIcons'

require('typeface-dosis')

Vue.use(Vuetify)
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
    //- Streamline icons
    values: StreamLineIcons
  },
  theme: {
    themes: {
      light: theme
    },
    options: {
      customProperties: true
    }
  },
  options: {
    minifyTheme(css) {
      return process.env.NODE_ENV === 'production' ? css.replace(/[\r\n|\r|\n]/g, '') : css
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

const LIST_ICON = '$sl-arrow-down';
VDataTableHeader.options.props.sortIcon.default = LIST_ICON;

export default vuetify
